import { sessionKey } from './constants';
import type { DevSession } from './interfaces/DevSession';
import { generateId } from './utils/id';
import { get, set } from './utils/storage';
import { getOrCreateUserId } from './utils/user';

export function createSession(
  application: string,
  devCommand?: string,
): DevSession {
  const session: DevSession = {
    application,
    sessionId: generateId(),
    userId: getOrCreateUserId(),
    startTime: Date.now(),
    stopTime: null,
    devCommand,
    hotReloads: [],
    env: {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      deviceMemory: (navigator as any).deviceMemory ?? null,
      hardwareConcurrency: navigator.hardwareConcurrency ?? null,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
      },
      hostname: window.location.hostname,
    },
  };
  set(sessionKey(application), session);
  return session;
}

export function getSession(application: string): DevSession | null {
  return get(sessionKey(application), null);
}

export function endSession(application: string): DevSession | null {
  const session = getSession(application);
  if (!session) return null;
  session.stopTime = Date.now();
  set(sessionKey(application), session);
  return session;
}

export function recordHotReload(
  application: string,
  duration: number,
  verbose = false,
) {
  const session = getSession(application);
  if (!session) return;

  session.hotReloads.push({
    timestamp: Date.now(),
    duration,
  });
  set(sessionKey(application), session);
  if (verbose) {
    // eslint-disable-next-line no-console
    console.debug(
      `[${application}] 🔥 Collected hot reload metric: ${duration}`,
    );
  }
}

export function clearSession(application: string) {
  localStorage.removeItem(sessionKey(application));
}
